import CopyDetails from './copy_details';

export default CopyDetails;
